import { render, staticRenderFns } from "./viscreen - 副本.vue?vue&type=template&id=3a477d32"
import script from "./viscreen - 副本.vue?vue&type=script&lang=js"
export * from "./viscreen - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports